<template>
  <div class="subcategories-manager">
    <div class="toolbar">
      <input
        class="regular clear search"
        placeholder="Search by subcategory name"
        type="text"
        v-model="nameFilter"
      />
      <label class="only-missing" v-if="missingImagesCount">
        <input type="checkbox" v-model="onlyMissing" />
        Only without image
        <span class="count">{{ missingImagesCount }}</span>
      </label>
      <span class="total">
        {{ subCategories.length }}
        {{ subCategories.length == 1 ? "subcategory" : "subcategories" }}
      </span>
      <button class="btn-dark-button new-btn" @click="createNewSubcategory()">
        + New subcategory
      </button>
    </div>

    <div v-if="activeSubcategory" ref="editor" class="editor">
      <div class="editor-image">
        <div
          class="preview"
          :class="{ empty: !showImage(activeSubcategory.subCategoryImage) }"
          @click="showFileSelector = true"
        >
          <img
            v-if="showImage(activeSubcategory.subCategoryImage)"
            :src="activeSubcategory.subCategoryImage"
            alt=""
            @error="markBroken(activeSubcategory.subCategoryImage)"
          />
          <div v-else class="placeholder">
            <img src="@/assets/icons/upload-clear.svg" alt="" />
            <span>
              {{
                hasImage(activeSubcategory.subCategoryImage)
                  ? "Image not found, upload a new one"
                  : "Upload image"
              }}
            </span>
          </div>
        </div>
        <div class="image-actions">
          <button class="link-btn" @click="showFileSelector = true">
            {{
              hasImage(activeSubcategory.subCategoryImage)
                ? "Change image"
                : "Upload image"
            }}
          </button>
          <button
            v-if="hasImage(activeSubcategory.subCategoryImage)"
            class="link-btn danger"
            @click="deleteSubcategoryImage()"
          >
            Remove image
          </button>
        </div>
      </div>
      <div class="editor-form">
        <div class="editor-header">
          <h3>
            {{
              newSubCategory
                ? "New subcategory"
                : originalSubcategory.subCategoryName
            }}
          </h3>
          <a class="close" @click="closeEditor()" title="Close">×</a>
        </div>
        <div class="fields">
          <div class="input-item">
            <label for="subcategory-name">Subcategory Name</label>
            <input
              id="subcategory-name"
              type="text"
              class="regular clear"
              v-model="activeSubcategory.subCategoryName"
            />
          </div>
          <div class="input-item">
            <label for="subcategory-url">Subcategory URL</label>
            <input
              id="subcategory-url"
              type="text"
              class="regular clear"
              @keyup="cleanSubcategoryUrl()"
              @change="cleanSubcategoryUrl()"
              v-model="activeSubcategory.subCategoryUrl"
            />
          </div>
          <div class="input-item">
            <label for="ebay-category-id">Ebay Store Category id</label>
            <input
              id="ebay-category-id"
              type="text"
              class="regular clear"
              v-model="activeSubcategory.ebayStoreCategoryId"
            />
          </div>
          <div class="input-item">
            <label for="status">Status</label>
            <BaseSwitchCustom id="status" v-model="activeSubcategory.status" />
          </div>
        </div>
        <div class="actions" v-if="changesPending">
          <button @click="discardChanges()" class="btn-dark-button">
            Discard changes
          </button>
          <button @click="confirmChanges()" class="btn-success-button">
            Confirm Changes
          </button>
        </div>
      </div>
    </div>
    <div v-if="activeSubcategory && activeSubcategory.id" class="items-panel">
      <SubcategoryItems
        :key="activeSubcategory.id"
        :subcategoryId="activeSubcategory.id"
      />
    </div>

    <div class="grid-list">
      <div
        class="sub-card"
        v-for="subCategory in subcategoriesFiltered"
        :key="subCategory.id"
        :class="{
          selected: activeSubcategory && activeSubcategory.id == subCategory.id,
          missing: !showImage(subCategory.subCategoryImage),
          inactive: subCategory.status != '1'
        }"
        @click="selectSubCategory(subCategory)"
      >
        <div class="cover">
          <img
            v-if="showImage(subCategory.subCategoryImage)"
            :src="subCategory.subCategoryImage"
            alt=""
            loading="lazy"
            @error="markBroken(subCategory.subCategoryImage)"
          />
          <div v-else class="placeholder">
            <img src="@/assets/icons/upload-clear.svg" alt="" />
            <span>
              {{
                hasImage(subCategory.subCategoryImage)
                  ? "Image not found"
                  : "No image"
              }}
            </span>
          </div>
          <span
            class="status-pill"
            :class="subCategory.status == '1' ? 'active' : 'disabled'"
          >
            {{ subCategory.status == "1" ? "Active" : "Inactive" }}
          </span>
          <a
            class="delete"
            title="Delete"
            @click.stop="deleteSubcategory(subCategory)"
          >
            <img src="@/assets/icons/trash.svg" />
          </a>
        </div>
        <div class="body">
          <div class="name">{{ subCategory.subCategoryName }}</div>
          <div class="url">/{{ subCategory.subCategoryUrl }}</div>
        </div>
      </div>
    </div>
    <div v-if="!subcategoriesFiltered.length" class="empty-state">
      {{
        subCategories.length
          ? "No subcategories match the filters."
          : "This category has no subcategories yet."
      }}
    </div>

    <FileSelector
      v-model="showFileSelector"
      type="assets"
      subcategory="image_category"
      @fileUploaded="fileUploaded"
      @selectedFile="fileUploaded"
    />
  </div>
</template>
<script>
import FileSelector from "@/components/FileSelector.vue";
import {
  updateSubCategory,
  requestDeleteSubcategory,
  hasImage
} from "@/api/store/CategoriesService.js";
import SubcategoryItems from "./SubcategoryItems.vue";
export default {
  components: {
    FileSelector,
    SubcategoryItems
  },
  props: {
    subCategories: {
      type: Array,
      required: true
    },
    categoryId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeSubcategory: null,
      originalSubcategory: null,
      showFileSelector: false,
      nameFilter: "",
      onlyMissing: false,
      // URLs que el navegador no pudo cargar
      brokenImages: {},
      i: 1
    };
  },
  computed: {
    missingImagesCount() {
      this.i;
      return this.subCategories.filter(
        sc => !this.showImage(sc.subCategoryImage)
      ).length;
    },
    subcategoriesFiltered() {
      this.i;
      let subCategories = this.subCategories;
      if (this.onlyMissing) {
        subCategories = subCategories.filter(
          sc => !this.showImage(sc.subCategoryImage)
        );
      }
      if (this.nameFilter != "") {
        subCategories = subCategories.filter(sc => {
          return sc.subCategoryName
            .toLowerCase()
            .includes(this.nameFilter.toLowerCase());
        });
      }
      return subCategories;
    },
    newSubCategory() {
      return this.activeSubcategory && !this.activeSubcategory.id;
    },
    changesPending() {
      return !(
        JSON.stringify(this.activeSubcategory) ==
        JSON.stringify(this.originalSubcategory)
      );
    }
  },
  methods: {
    hasImage,
    showImage(url) {
      return hasImage(url) && !this.brokenImages[url];
    },
    markBroken(url) {
      this.$set(this.brokenImages, url, true);
    },
    cleanSubcategoryUrl() {
      this.activeSubcategory.subCategoryUrl = this.activeSubcategory.subCategoryUrl
        .replace(/[ -]/g, "_")
        .replace(/\W/g, "")
        .toLowerCase();
    },
    fileUploaded(file) {
      this.activeSubcategory.subCategoryImage = file.s3Url;
    },
    scrollToEditor() {
      this.$nextTick(() => {
        if (this.$refs.editor) {
          this.$refs.editor.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
    },
    createNewSubcategory() {
      this.originalSubcategory = null;
      this.activeSubcategory = {
        id: null,
        status: "0",
        categoryId: this.categoryId,
        subCategoryImage: null,
        subCategoryName: "",
        subCategoryUrl: ""
      };
      this.scrollToEditor();
    },
    selectSubCategory(subCategory) {
      this.originalSubcategory = { ...subCategory };
      this.activeSubcategory = { ...subCategory };
      this.scrollToEditor();
    },
    closeEditor() {
      this.activeSubcategory = null;
      this.originalSubcategory = null;
    },
    discardChanges() {
      if (!this.originalSubcategory) {
        this.closeEditor();
        return;
      }
      this.activeSubcategory = { ...this.originalSubcategory };
    },
    async confirmChanges() {
      let res = await updateSubCategory(
        this.activeSubcategory.id,
        this.activeSubcategory
      );
      if (res.status == "success") {
        this.$toast.open({
          message: res.message,
          type: "success",
          position: "top-right"
        });
        if (!this.activeSubcategory.id) {
          this.$emit("createdSubcategory", res.category);
        } else {
          this.$emit("updatedSubcategory", res.category);
        }
        this.activeSubcategory = { ...res.category };
        this.originalSubcategory = { ...res.category };
        this.i = this.i + 1;
      } else {
        this.$toast.open({
          message: `Error updating category`,
          type: "error",
          position: "top-right"
        });
      }
    },
    async deleteSubcategoryImage() {
      this.activeSubcategory.subCategoryImage = null;
    },
    async deleteSubcategory(subcategory) {
      if (
        confirm(
          "Do you want to delete the subcategory " + subcategory.subCategoryName
        )
      ) {
        const response = await requestDeleteSubcategory(subcategory.id);
        if (response.status == "error") {
          this.$toast.open({
            message: `${response.message}`,
            type: "error",
            position: "top-right"
          });
        } else {
          this.$emit("subcategoryDeleted", subcategory);
          if (
            this.activeSubcategory &&
            subcategory.id == this.activeSubcategory.id
          ) {
            this.closeEditor();
          }
          this.i = this.i + 1;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/App.scss";

$warning: #f5a623;
$warning-bg: #fff8ee;
$warning-text: #a15c00;

.subcategories-manager {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  .search {
    flex: 1 1 260px;
    max-width: 420px;
  }
  .only-missing {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    cursor: pointer;
    .count {
      background-color: #fde2e1;
      color: #a61b1b;
      font-size: 12px;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 10px;
    }
  }
  .total {
    font-size: 13px;
    color: #6b7280;
  }
  .new-btn {
    margin-left: auto;
  }
}

.editor {
  display: grid;
  grid-template-columns: minmax(220px, 320px) 1fr;
  gap: 24px;
  padding: 16px;
  border: 1px solid #d6e4f5;
  background-color: #f7fbff;
  border-radius: 10px;
  scroll-margin-top: 20px;
  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
  .editor-image {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .preview {
      aspect-ratio: 185 / 120;
      border-radius: 8px;
      overflow: hidden;
      background-color: #fff;
      border: 1px solid #e5e7eb;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      &.empty {
        border: 2px dashed $warning;
        background-color: $warning-bg;
      }
    }
    .image-actions {
      display: flex;
      gap: 16px;
    }
  }
  .editor-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    .editor-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        font-size: 17px;
        font-weight: 600;
      }
      .close {
        font-size: 24px;
        line-height: 1;
        color: #6b7280;
        cursor: pointer;
        &:hover {
          color: #111827;
        }
      }
    }
    .fields {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px 16px;
      @media screen and (max-width: 600px) {
        grid-template-columns: 1fr;
      }
    }
    .input-item {
      display: flex;
      flex-direction: column;
      label {
        margin-bottom: 6px;
        font-size: 13px;
        color: #4b5563;
      }
    }
    .actions {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
    }
  }
}

.items-panel {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.link-btn {
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
  &:hover {
    text-decoration: underline;
  }
  &.danger {
    color: #a61b1b;
  }
}

.placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: $warning-text;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  padding: 8px;
  img {
    width: 32px;
    opacity: 0.7;
  }
}

.grid-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 14px;
  .sub-card {
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
    &:hover {
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
      .delete {
        opacity: 1;
      }
    }
    &.selected {
      border-color: #3b82f6;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.35);
    }
    &.missing {
      border-color: $warning;
      .cover {
        border-bottom: 2px dashed $warning;
        background-color: $warning-bg;
      }
    }
    &.inactive .cover > img {
      filter: grayscale(1);
      opacity: 0.6;
    }
    .cover {
      position: relative;
      aspect-ratio: 185 / 120;
      background-color: #f3f4f6;
      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .status-pill {
        position: absolute;
        top: 6px;
        left: 6px;
        font-size: 10px;
        font-weight: 600;
        padding: 2px 7px;
        border-radius: 10px;
        &.active {
          background-color: rgba(232, 246, 236, 0.95);
          color: #2d6a2d;
        }
        &.disabled {
          background-color: rgba(253, 226, 225, 0.95);
          color: #a61b1b;
        }
      }
      .delete {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 28px;
        height: 28px;
        padding: 5px;
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 0.95);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
        opacity: 0;
        transition: opacity 0.15s ease;
        &:hover {
          background-color: $M8;
        }
        img {
          width: 100%;
        }
      }
    }
    .body {
      padding: 8px 10px 10px;
      .name {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.25;
      }
      .url {
        font-size: 11px;
        color: #9ca3af;
        margin-top: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.empty-state {
  padding: 40px 0;
  text-align: center;
  color: #6b7280;
}
</style>
